import BarGraph from '../SalaryBarGraph';
import { S } from '../style';

interface Props {
  labels: string[];
  values: number[];
}

function EmptySalary({ labels, values }: Props) {
  return (
    <S.GraphCard>
      <S.Title>수집 중..</S.Title>
      <S.SubTitle typography='midium150_C1'>다른 출처를 선택해보세요.</S.SubTitle>
      <BarGraph labels={labels} values={values} />
    </S.GraphCard>
  );
}

export default EmptySalary;
